import { useState } from "react";
import { Button, Field, Sheet } from "./ui";
import { requestReset } from "../lib/reset";

export const ForgotPassword = ({ initialEmail, onClose }) => {
  const [email, setEmail] = useState(initialEmail || "");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [sent, setSent] = useState("");

  const submit = async (e) => {
    e?.preventDefault();
    if (!email.trim()) return setError("Introduza o seu email.");
    setError("");
    setBusy(true);
    try {
      const r = await requestReset(email.trim());
      setSent(r.message);
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <Sheet title="Recuperar palavra-passe" onClose={onClose} testid="forgot-password-sheet">
      {sent ? (
        <>
          <p data-testid="forgot-password-sent" style={{ color: "var(--on-surface-2)", fontSize: 15, lineHeight: 1.5, margin: 0 }}>
            {sent} Verifique também a pasta de spam.
          </p>
          <Button onClick={onClose} data-testid="forgot-password-close-button">ENTENDIDO</Button>
        </>
      ) : (
        <form onSubmit={submit} style={{ display: "flex", flexDirection: "column", gap: 16 }}>
          <p style={{ color: "var(--on-surface-3)", fontSize: 15, lineHeight: 1.5, margin: 0 }}>
            Indique o email da sua conta. Vamos enviar-lhe um link para definir uma nova palavra-passe.
          </p>
          <Field label="EMAIL" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="nome@exemplo.pt" autoComplete="email" data-testid="forgot-password-email" />
          {error ? <div data-testid="forgot-password-error" style={{ background: "var(--error)", color: "var(--on-error)", padding: 12, borderRadius: "var(--r-md)", fontSize: 13 }}>{error}</div> : null}
          <Button type="submit" loading={busy} data-testid="forgot-password-submit">ENVIAR LINK</Button>
        </form>
      )}
    </Sheet>
  );
};
